<template>
  <v-app class="app">
    <v-main>
      <Metronome/>
    </v-main>
  </v-app>
</template>

<script>
import Metronome from './components/Metronome.vue'

export default {
  name: 'App',

  components: {
    Metronome,
  },

  data: () => ({
    //
  }),
}
</script>
<style>

.app {
  background-color: #ebcc9e;
  background-image: linear-gradient( rgba(235, 204, 158, 0.80)), url('./assets/background_sara.png');
  background-repeat: repeat-x;
  background-position: 95% 88%;
}

.v-overlay__content {
  background-color: #ebcc9e !important;
}

.v-overlay__content .v-list {
  background-color: #ebcc9e !important;
}

.v-overlay__content .v-scroll {
  background-color: #ebcc9e !important;
}

.v-overlay__content .v-sheet {
  background-color: #ebcc9e !important;
}

.v-overlay__content ::-webkit-scrollbar {
  width: 8px;
}

.v-overlay__content ::-webkit-scrollbar-track {
  background: #ebcc9e;
  border-radius: 10px;
}

.v-overlay__content ::-webkit-scrollbar-thumb {
  background: #c4a166;
  border-radius: 10px;
}

.v-overlay__content ::-webkit-scrollbar-thumb:hover {
  background: #a38154;
}

</style>
